import * as React from 'react';
import { LoaderScreen } from '@grandvisionhq/common';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { Alert } from '@grandvisionhq/iris-ui';
import { useDispatch, useSelector, statusSuccess, useIntl } from '@grandvisionhq/state';
import '../../state/actions.js';
import '../../state/add-to-cart/selectors.js';
import '../../state/bundles/selectors.js';
import '../../state/bundles/reducer.js';
import { getSelectedFrame, getAddOns, getSelectedAddOn } from '../../state/configurator/selectors.js';
import '../../state/configurator/reducer.js';
import '../../state/products/selectors.js';
import '../../state/products/reducer.js';
import { VariantSelectionStep } from '../components/VariantSelectionStep/VariantSelectionStep.js';
import { selectAddOn } from '../../state/configurations/actions.js';

const LensAddOnVariantStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    const frame = useSelector(getSelectedFrame);
    const addOns = useSelector(getAddOns);
    const selectedLensAddOn = useSelector(getSelectedAddOn);
    const onChange = React.useCallback((sku)=>{
        if (!frame) {
            return;
        }
        dispatch(selectAddOn({
            frameSku: frame.sku,
            addOnSku: sku,
            reason: 'user selection'
        }));
    }, [
        dispatch,
        frame
    ]);
    const variantsList = selectedLensAddOn === null || selectedLensAddOn === void 0 ? void 0 : selectedLensAddOn.variants;
    if (!statusSuccess(addOns)) {
        return /*#__PURE__*/ React.createElement(LoaderScreen, null);
    }
    if (!variantsList || variantsList.length === 0) {
        return /*#__PURE__*/ React.createElement(Failed, null);
    }
    return /*#__PURE__*/ React.createElement(VariantSelectionStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        itemsList: variantsList,
        selectedItemSku: selectedLensAddOn === null || selectedLensAddOn === void 0 ? void 0 : selectedLensAddOn.sku
    });
};
function Failed() {
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Alert, {
        variant: "error",
        title: getLabel('products.glasses.configurator.error'),
        className: "alert-m-default variant-selection-step__alert"
    });
}

export { LensAddOnVariantStepContainer };
//# sourceMappingURL=LensAddOnVariantStepContainer.js.map
